import React, { useState, useEffect } from 'react';
import { XMarkIcon, ArrowDownTrayIcon, ShareIcon } from '@heroicons/react/24/outline';
import { useInstallPrompt } from '../hooks/useInstallPrompt';

const DISMISS_KEY = 'pwa-install-dismissed';

const InstallBanner: React.FC = () => {
  const { canInstall, isIosSafari, promptInstall } = useInstallPrompt();
  const [dismissed, setDismissed] = useState(true);

  useEffect(() => {
    setDismissed(localStorage.getItem(DISMISS_KEY) === 'true');
  }, []);

  if (!canInstall || dismissed) return null;

  const handleDismiss = () => {
    localStorage.setItem(DISMISS_KEY, 'true');
    setDismissed(true);
  };

  return (
    <div className="fixed bottom-24 sm:bottom-4 left-4 right-4 sm:left-auto sm:right-4 sm:w-80 z-50 bg-surface border border-edge rounded-xl shadow-lg p-4 animate-in slide-in-from-bottom-4">
      <button
        onClick={handleDismiss}
        className="absolute top-2 right-2 p-1 text-muted hover:text-heading rounded-lg"
        aria-label="Dismiss"
      >
        <XMarkIcon className="h-4 w-4" />
      </button>

      {isIosSafari ? (
        <div className="pr-6">
          <p className="text-sm font-medium text-heading">Install Board Game Stats</p>
          <p className="text-xs text-body mt-1">
            Tap <ShareIcon className="inline h-4 w-4 align-text-bottom" /> Share, then "Add to Home Screen"
          </p>
        </div>
      ) : (
        <div className="flex items-center gap-3 pr-6">
          <div className="flex-1">
            <p className="text-sm font-medium text-heading">Install Board Game Stats</p>
            <p className="text-xs text-body mt-0.5">Add to your home screen for quick access</p>
          </div>
          <button
            onClick={promptInstall}
            className="shrink-0 flex items-center gap-1.5 px-3 py-1.5 text-sm font-medium rounded-lg bg-primary-600 text-white hover:bg-primary-700 transition-colors"
          >
            <ArrowDownTrayIcon className="h-4 w-4" />
            Install
          </button>
        </div>
      )}
    </div>
  );
};

export default InstallBanner;
